import React, {PropTypes} from "react";
import {connect} from "react-redux";
import axios from "axios";
import TeamTable from "./TeamTable";
import ModalView from "../../hradmin/PeopleSearch/components/ModalView";
import ModalApply from "./Modals/ModalApply";
import ModalAbscond from "./Modals/ModalAbscond";
import ModalExitView from "../MyExit/ModalExitView";
import ModalConfirm from "./Modals/ModalConfirm";
import Modal from "react-bootstrap/lib/Modal";
import Checkbox from "material-ui/Checkbox";
import csvConvert from "../../../classes/csvConvert";
import moment from "moment";
import Button from "react-bootstrap/lib/Button";

class ManagerSS extends React.Component {

  constructor() {
    super();
    this.state = ({
      teamEmployee: [],

      exit: false,
      name: "",
      empId:"",
      employee: {},
      open: false,
      showExit: false,
      openExit: false,
      editExit: false,
      approve: false,
      openExitManager: false,
      showAbscond:false,
      url: "/applyExit"
    })
    this.getEmployee = this.getEmployee.bind(this);

    this.close = this.close.bind(this);
    this.closeExit = this.closeExit.bind(this);
    this.refresh = this.refresh.bind(this);
    this.showExit = this.showExit.bind(this);
    this.moveToAbscond = this.moveToAbscond.bind(this);
    this.openEditExit = this.openEditExit.bind(this);
    this.closeEditExit = this.closeEditExit.bind(this);
    this.showEditExit = this.showEditExit.bind(this);
    this.openApprove = this.openApprove.bind(this);
    this.closeApprove = this.closeApprove.bind(this);
    this.showExitEmployee = this.showExitEmployee.bind(this);
    this.closeExitEmployee = this.closeExitEmployee.bind(this);
    this.downloadCsv = this.downloadCsv.bind(this);
    this.submitAbscondInfo = this.submitAbscondInfo.bind(this);
    this.closeAbscond = this.closeAbscond.bind(this);
  }

  downloadCsv() {
    let csvContent = new csvConvert();
    let tableData = csvContent.convertArrayOfVerticalObjectsToCSV({data: this.state.teamEmployee});
    console.log(tableData);
    let filename = moment(new Date()).format('YYYY-MM-DD');

    let blob = new Blob([tableData], {type: "text/csv;charset=utf-8;"});
    blob = window.URL.createObjectURL(blob);

    if (!tableData.match(/^data:text\/csv/i)) {
      tableData = 'data:text/csv;charset=utf-8,' + tableData;
    }
    let getCsv = new Promise((resolve, reject)=> {
      this.setState({csv: blob})
      resolve(true);
    });
    getCsv.then((response)=> {
      this.download.click();
    })
  }

  showExitEmployee(empId) {
    axios.get(process.env.REQ_URL + "/getExitById?q=" + empId, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {


      this.setState({employee: response.data.data, showExit: true})

    }).catch((error) => {
      console.log(error);
    });

  }

  closeExitEmployee() {
    this.setState({showExit: false})
  }

  openApprove(empId) {
    axios.get(process.env.REQ_URL + "/getExitById?q=" + empId, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {


      this.setState({employee: response.data.data, approve: true})

    }).catch((error) => {
      console.log(error);
    });

  }

  closeApprove() {
    this.setState({approve: false})
  }

  openEditExit() {
    this.setState({editExit: true});
  }

  closeEditExit() {
    this.setState({editExit: false})
  }

  closeExit() {
    this.setState({openExit: false})
  }

  showEditExit(empId) {
    axios.get(process.env.REQ_URL + "/getExitById?q=" + empId, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.setState({employee: response.data.data, editExit: true})
    }).catch((error) => {
      console.log(error);
    });
  }

  showExit(empId) {
    axios.get(process.env.REQ_URL + "/aboutEmp?q=" + empId, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.setState({employee: response.data.data, openExit: true, url: "/applyExit"})

    }).catch((error) => {
      console.log(error);
    });
  }

  moveToAbscond(empId) {
    this.setState({
      empId:empId,
      showAbscond:true
    });
  }

  submitAbscondInfo(data){

      let AbscondedFrom = data.AbscondedFrom.getTime();
      let AbscondedTo=data.AbscondedTo.getTime();

      let request = {
            "AbscondedFrom":AbscondedFrom,
            "AbscondedTo":AbscondedTo,
            "empId":this.state.empId,
            "remarks":"Employee not came last three days",
            "noticePeriodStatus":"Abscond",
            "typeOfExit": "Abscond",
            "lastWorkingDay":AbscondedFrom,
            "id":null
          }
      axios.post(process.env.REQ_URL + "/exit/moveToAbscond", {data: request}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        this.setState({
          showAbscond:false
        });
        this.refresh();
      }).catch((err)=> {
            console.log("Error Occurred");
      });

  }

  getEmployee(empId) {
    axios.get(process.env.REQ_URL + "/aboutEmp?q=" + empId, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.setState({employee: response.data.data, open: true})
    }).catch((error) => {
      console.log(error);
    });
  }

  close() {
    this.setState({open: false});
  }

  closeAbscond() {
    this.setState({showAbscond:false});
  }

  refresh() {
    axios.get(process.env.REQ_URL + "/aboutEmployeeTeamWithAttendance?q=" + this.props.employee.empno, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      if (this.state.exit) {
        let teamEmployees = Object.assign([], this.state.teamEmployee);
        let team = new Array();
        teamEmployees = teamEmployees.map((node)=> {
          console.log(node.empStatus);
          if (node.empStatus != 'A')
            team.push(node);
        })

        this.setState({teamEmployee: team})
      }
      else {
        this.setState({teamEmployee: response.data.data})
      }


    }).catch((error) => {
      console.log(error);
    });
  }
  refreshIndirect() {
    axios.get(process.env.REQ_URL + "/aboutEmpTeamIndirect?q=" + this.props.employee.empno, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {

      if (this.state.exit) {
        let teamEmployees = Object.assign([], this.state.teamEmployee);
        let team = new Array();
        teamEmployees = teamEmployees.map((node)=> {
          console.log(node.empStatus);
          if (node.empStatus != 'A')
            team.push(node);
        })

        this.setState({teamEmployee: team})
      }
      else {
        this.setState({teamEmployee: response.data.data})
      }


    }).catch((error) => {
      console.log(error);
    });
  }

  componentDidMount() {
    this.props.changeBanner("My Team");
    axios.get(process.env.REQ_URL + "/aboutEmployeeTeamWithAttendance?q=" + this.props.employee.empno, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.setState({teamEmployee: response.data.data})
    }).catch((error) => {
      console.log(error);
    });
  }

  componentWillReceiveProps(props) {
    if (props.employee != null || props.employee != undefined) {
      axios.get(process.env.REQ_URL + "/aboutEmployeeTeamWithAttendance?q=" + this.props.employee.empno, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        this.setState({teamEmployee: response.data.data})
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  render() {
    console.log(this.props.employee);
    const empno = this.props.employee.empno;
    const empName = this.props.employee.empName;
    return (
      <div>
        {this.state.open ? <ModalView
          employee={this.state.employee}
          open={this.state.open}
          close={this.close}
          display="none"
          showEmployee={this.getEmployee}
        /> : null}
        {this.state.openExit ? <ModalApply
          open={this.state.openExit}
          employee={this.state.employee}
          refresh={this.refresh}
          close={this.closeExit}
          url={this.state.url}
        /> : null}
        {this.state.openExitManager ? <ModalExit
          open={this.state.openExit}
          employee={this.state.employee}
          refresh={this.refresh}
          close={this.closeExit}
          url={this.state.url}
        /> : null}
        {this.state.editExit ? <ModalConfirm
          open={this.state.editExit}
          employee={this.state.employee}
          refresh={this.refresh}
          close={this.closeEditExit}
          empRefresh={this.refresh}
          url={this.state.url}
        /> : null}
        {this.state.showExit ? <Modal
          bsSize="medium"
          show={this.state.showExit} onHide={this.closeExitEmployee}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.employee.employeeCode} : {this.state.employee.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{borderStyle: 'solid', borderWidth: '0.5px'}}>
            <ModalExitView employee={this.state.employee}/>
            &nbsp;
          </Modal.Body>
        </Modal> : null}
        {this.state.showAbscond ? <ModalAbscond
          open={this.state.showAbscond}
          close={this.closeAbscond}
          submitHandler={this.submitAbscondInfo}
          />:null
        }

        <div className="col-md-4" style={{paddingTop: 20}}>
          <div className="col-sm-12" style={{'textAlign': 'left', 'padding': 0, marginLeft: '15'}}>
            <div className="col-sm-4">
              <Button
                onClick={this.downloadCsv}
                style={{backgroundColor: 'rgb(92, 184, 92)', marginLeft: '-20px', marginTop: '-10px'}}
              ><i className="glyphicon glyphicon-download-alt">&nbsp;</i>Download</Button>
            </div>
            <div className="col-sm-4">
              <Checkbox label="InExit"
                        onCheck={()=> {
                          if (!this.state.exit) {
                            let teamEmployees = Object.assign([], this.state.teamEmployee);
                            let team = new Array();
                            teamEmployees = teamEmployees.map((node)=> {
                              console.log(node.empStatus);
                              if (node.empStatus != 'A')
                                team.push(node);
                            })
                            console.log(teamEmployees);
                            this.setState({teamEmployee: team, exit: !this.state.exit})
                          }
                          else {
                            if (this.state.indirect) {
                              this.refreshIndirect();
                              this.setState({exit: !this.state.exit});}
                            else
                            {
                              this.refresh();
                              this.setState({exit: !this.state.exit})
                            }
                          }
                        }}
                        checked={this.state.exit}
                        iconStyle={{boxColor: '#FADFFF'}}/>
            </div>
            <div className="col-sm-4">
              <Checkbox label="Indirect"
                        onCheck={()=> {
                          if (!this.state.indirect) {
                          this.refreshIndirect();
                            this.setState({indirect: !this.state.indirect});}
                            else
                          {
                            this.refresh();
                            this.setState({indirect: !this.state.indirect})
                          }

                        }}
                        checked={this.state.indirect}
                        iconStyle={{boxColor: '#FADFFF'}}/>
            </div>

          </div>
          <div className="col-sm-6" style={{'textAlign': 'right', display: 'inline', marginLeft: '5px'}}>
          </div>
        </div>
        <a href={this.state.csv} download={this.state.indirect? "MyIndirectTeam" + moment(new Date()).format('YYYY-MM-DD') + ".csv":"MyTeam" + moment(new Date()).format('YYYY-MM-DD') + ".csv"}
           ref={(input) => {
             this.download = input;
           }}/>


        <TeamTable teamEmployee={this.state.teamEmployee}
                   showEmployee={this.getEmployee}
                   viewExit={this.showExitEmployee}
                   showExit={this.showExit}
                   editExit={this.showEditExit}
                   moveToAbscond = {this.moveToAbscond}
                   showApprove={this.openApprove}/>
      </div>
    );
  }

}

ManagerSS.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    employee: state.emp[0]
  };

}


export default connect(mapStateToProps)(ManagerSS);




/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/ManagerSS/ManagerSS.js
 **/